import React from 'react';
import { Route } from 'react-router-dom';

import { CrossJudicial } from './info/judicial';
import ReferralTerms from './terms/referral';

export default () => [
  <Route
    exact
    path="/conteudo/recuperar-garantia-trabalhista"
    key="cross-judicial"
    component={CrossJudicial}
  />,
  <Route
    exact
    path="/conteudo/termos-programa-de-indicacao"
    key="terms-referral"
    component={ReferralTerms}
  />,
];
